<script>
	import {
    Card,CardBody,CardFooter,CardHeader,CardSubtitle,
    CardText,CardTitle,Styles} from 'sveltestrap';
	import {getNinja} from './NinjaAPI.svelte' 
	export let params = {}
	let ninja 
	$: ninja = getNinja(params.id)
</script>
{#if ninja}
<Card class="mb-3" style="max-width:600px">
  <CardHeader>
    <CardTitle>{ninja.name}</CardTitle>
  </CardHeader>
  <CardBody>
    <CardSubtitle>ความเป็นมา</CardSubtitle>
    <CardText>
		<img src={ninja.img} alt={ninja.alt} width="200" style="float:right">
		{ninja.detail}
		</CardText>
  </CardBody>
</Card>
{/if}
<Styles/>